import IFileService from "data/IFileService";
import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";
import RoundButton from "features/shared/components/buttons/RoundButton";
import DateFormatter from "features/shared/components/formatters/DateFormatter";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React from "react";

type Props = {
  document: DocumentSimplifiedDTO;
};

const ContractDocument = ({ document }: Props) => {
  // DI
  const fileService = useInjection<IFileService>(IocTypes.FileService);

  // hadlers
  const fileDownloadHandler = () => {
    fileService.downloadDocument(document);
  };

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm-6">
            <div className="row no-gutters align-items-center">
              <div className="col-auto col-sm-6">{document.documentType}</div>
              <div className="d-sm-none col-auto px-2 mt-n1">
                <span className="d-inline-block mt-n1 text-muted small">|</span>
              </div>
              <div className="col-auto col-sm-6 text-center">
                <DateFormatter date={document.date!} />
              </div>
            </div>
          </div>
          <div className="col-sm-6 text-truncate text-muted">{document.name}</div>
        </div>
      </div>
      <div className="col-auto pl-3">
        <RoundButton icon="file-pdf" onClickHandler={fileDownloadHandler} />
      </div>
    </div>
  );
};

export default ContractDocument;
